import { render, staticRenderFns } from "./documentField.vue?vue&type=template&id=55f57cae&"
import script from "./documentField.vue?vue&type=script&lang=ts&"
export * from "./documentField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports